module.exports = __webpack_public_path__ + "static/media/5-menu.ef11f9d1.svg";